import React from "react";

interface AdminRenderProps {}

const AdminRender: React.FC<AdminRenderProps> = ({}) => {
    return <p>Admin Render</p>;
};
export default AdminRender;
